import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { DiscountModule } from './discount.module';
platformBrowserDynamic().bootstrapModule(DiscountModule);
